<template>
  <div class="container-fluid">
    <div class="container p-0 card_background_effect">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-md-0">
          <div class="login-form d-flex">

            <form
              class="sign-in-sign-up-form w-100"
              ref="form"
              data-url="/user/confirm"
              action="store"
            >
              <div class="text-center mb-3">
                <img
                  :src="
                    configData.company_logo
                      ? configData.company_logo
                      : '/images/core.png'
                  "
                  alt=""
                  class="img-fluid logo"
                />
                <div class="form-row mt-5">
                  <div class="form-group col-12 text-right mb-3">
                    <a href="/admin/users/login" class="btn btn-dark btn-with-shadow">Members Login</a>

                  </div>
                </div>
              </div>
              <div>
                <div class="row">

                  <div class="col-sm-1">
                    <div style="height: auto">
                      <el-steps :direction="isMobile" :active="active">
                        <el-step></el-step>
                        <el-step></el-step>
                        <el-step></el-step>
                        <el-step></el-step>
                        <!-- <el-step></el-step> -->
                        <!-- <el-step></el-step> -->
                      </el-steps>
                    </div>
                  </div>
                  <div class="col-sm-11">
                    <el-form v-if="active === 1">
                      <app-registrationstepone-view
                        @role="setRole"
                        :active="{ active }"
                      />
                    </el-form>
                    <el-form v-if="active === 2">
                      <div class="mt-3">
                        <div class="form-row">
                          <div class="form-group col-11">
                            <h3 class="text-center mb-0">
                              {{ $t("company_information") }}
                            </h3>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-12">
                            <label for="">
                              {{ $t("are_you_register_with_comopany_house") }}
                            </label>
                            <app-input
                              class="mt-2 pt-1"
                              type="radio"
                              :list="genderLists"
                              v-model="company.yes"
                              :required="true"
                              v-on:click="handleSelectTwo"
                            />
                          </div>
                        </div>
                        <div class="form-row" v-if="company.yes === 'yes'">
                          <div class="form-group col-12">
                            <label for="">
                              {{ $t("Search by company name or number") }}
                            </label>
                            <div class="d-flex">
                              <el-autocomplete
                                class="inline-input col-12 px-0"
                                v-model="state2"
                                :fetch-suggestions="querySearch"
                                placeholder="Please Input name or number"
                                :trigger-on-focus="false"
                                @select="handleSelect"
                              ></el-autocomplete>
                              <a
                                :trigger-on-focus="false"
                                class="search_link"
                                @click="querySearch(searchparam, cb)"
                              >
                                <app-icon name="search" />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("company_name")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="company.title"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div>
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("company_number")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="company.company_number"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div>
                        </div>

                        <div class="form-row">
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("address_line_1")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="company.address_line_1"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div>
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("address_line_2")
                            }}</label>
                            <app-input
                              type="text"
                              v-model="company.address_line_2"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div>
                        </div>

                        <div class="form-row">
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("country")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="company.country"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div>
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("locality")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="company.locality"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div>
                        </div>

                        <div class="form-row">
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("premises_house_number")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="company.premises"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div>
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("postal_code")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="company.postal_code"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div>
                          <!-- <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("status")
                            }}</label>
                            <app-input
                              type="text"
                              v-model="company.status"
                              :required="true"
                              :read-only="readOnly"
                            />
                          </div> -->
                        </div>

                        <!-- <div class="form-row" v-if="company.yes === 'yes'">
                          <div class="form-group col-12">
                            <label for="user_password">{{
                              $t("address")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="company.address_snippet"
                              :read-only="readOnly"
                            />
                          </div>
                        </div> -->

                        <div class="form-row" v-if="recaptchaEnable == 1">
                          <div class="form-group col-12 px-0">
                            <re-captcha :site-key="siteKey"></re-captcha>
                          </div>
                        </div>
                      </div>
                    </el-form>
                    <el-form v-if="active === 3">
                      <div class="mt-3">
                        <div class="form-row">
                          <div class="form-group col-11 text-center">
                            <h3 class="text-center mb-0">
                              {{ $t("account_information") }}
                            </h3>
                            <label for="">
                              {{ $t("enter_your_details_blow") }}
                            </label>
                          </div>
                        </div>

                        <div class="form-row">
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("first_name")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="text"
                              v-model="user.first_name"
                              :required="true"
                            />
                          </div>
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("last_name")
                            }}</label>
                            <app-input
                              type="text"
                              v-model="user.last_name"
                              :required="true"
                            />
                          </div>
                        </div>

                        <div class="form-row">
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_number">{{
                              $t("phone")
                            }}</label>
                            <app-input
                                type="tel-input-custom"
                                v-model="user.number"
                                @input="userNumber"
                              :required="true"
                            />
                          </div>
                          <div class="form-group col-lg-6 col-sm-12">
                            <label for="user_first_name">{{
                              $t("email")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="email"
                              v-model="user.email"
                              :required="true"
                            />
                          </div>
                        </div>

                        <div class="form-row">
                          <div class="form-group col-12">
                            <label for="user_password">{{
                              $t("password")
                            }}<b class="text-danger"> *</b></label>
                            <app-input
                              type="password"
                              v-model="user.password"
                              :specialValidation="true"
                              :placeholder="$t('enter_your_password')"
                              :required="true"
                            />
                            <PasswordWarning />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-12">
                            <label for="user_password_confirmation">
                              {{ $t("confirm_password") }}<b class="text-danger"> *</b>
                            </label>
                            <app-input
                              type="password"
                              same-as="user_password"
                              v-model="user.password_confirmation"
                              :placeholder="$t('confirm_password')"
                              :required="true"
                            />
                          </div>
                        </div>
                        <div class="form-row" v-if="recaptchaEnable == 1">
                          <div class="form-group col-12 px-0">
                            <re-captcha :site-key="siteKey"></re-captcha>
                          </div>
                        </div>
                      </div>
                    </el-form>
                    <el-form v-if="active === 4">
                      <div class="mt-3">
                        <div class="form-row">
                          <div class="form-group col-11">
                            <h3 class="text-center mb-0">Thanks</h3>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="
                            row
                            justify-content-center
                            align-items-center
                            h-100
                            white-base-color
                          "
                        >
                          <div
                            class="col-12 col-sm-9 col-md-7 col-lg-5 col-xl-6"
                          >
                            <div class="text-center">
                              <img
                                :src="'/images/email_image.jpg'"
                                alt=""
                                class="img-fluid d-block mx-auto"
                                style="max-width: 400px"
                              />
                              <h5 class="my-4">We have sent an email</h5>
                              <p class="text-muted mb-4">
                                Thank you for registering with us! <br />
                                We have sent a verification email to verify your
                                email address. Kindly check your email to verify
                                your account.
                              </p>
                              <app-button
                                :preloader="preloader"
                                :label="'Go to Dashboard'"
                                class-name="btn btn-primary text-center"
                                @submit="goDashboard"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div
                          class="col-lg-2 col-md-2 col-sm-12"
                          v-for="subCat in category.subCategories"
                          v-bind:key="subCat.id"
                          v-on:click="getSubCategory(subCat.id)"
                          style="cursor: pointer"
                        >
                          <div class="certificate_boxes">
                            <button type="button" class="butoon_focus">
                              <img :src="subCat.image" alt="" width="100px" />
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                          <h3 style="font-size: 1.75rem">
                            {{ subCategory.title }}
                          </h3>
                          <p class="mt-3">
                            {{ subCategory.description }}
                          </p>
                        </div>
                      </div>
                    </el-form>
                    <el-form v-if="active === 5">
                      <div class="mt-3">
                        <div class="form-row">
                          <div class="form-group col-11">
                            <h3 class="text-center mb-0">
                              {{ $t("package_section") }}
                            </h3>
                            <!-- <div class="widget-data mt-3 ml-0 text-center">
                              <h6 class="mt-3">{{ $t("three_months") }}</h6>
                            </div> -->
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col-lg-4 col-md-6 col-sm-12"
                          v-for="p in packages"
                          v-bind:key="p.id"
                        >
                          <div class="card">
                            <div class="card-body">
                              <div class="card-title" style="display: inline-flex; align-items: center;">
                                <img
                                  src="https://my.chas.co.uk/assets/img/bundle/standard.png"
                                  alt=""
                                  style="max-width: 70px; height: 70px"
                                />
                                <h5 style="font-size: 1.25rem">
                                  {{ p.title }}
                                </h5>
                              </div>
                              <div class="card-text">
                                <div>
                                  <ul class="ul_pricing_succes">
                                    <li v-for="i in p.include" v-bind:key="i">
                                      {{ i }}
                                    </li>
                                  </ul>
                                </div>
                                <div>
                                  <!-- <ul class="ul_pricing_fail">
                                          <li>Financial</li>
                                          <li>Identity</li>
                                          <li>Corporate & Professional Standing</li>
                                          <li>Environmental</li>
                                          <li>Quality</li>
                                          <li>Equality</li>
                                          <li>Modern Slavery </li>
                                          <li>Anti-Bribery & Corruption </li>
                                          <li>Corporate Social Responsibility </li>
                                          <li>Information Security and GDPR</li>
                                          <li>Building Information Modelling (BIM)</li>
                                        </ul> -->
                                </div>
                                <div class="price_center">
                                  <small class="text-muted_">
                                    Prices starting from:
                                  </small>
                                  <h2>${{ p.amount }}</h2>
                                  <a
                                    href="#"
                                    class="
                                      btn btn-primary btn-with-shadow btn-block
                                    "
                                  >
                                    Find out more
                                  </a>
                                  <a
                                    href="#"
                                    class="
                                      btn btn-dark btn-with-shadow btn-block
                                    "
                                    v-on:click="payment(p.id)"
                                  >
                                    Select
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form>
                    <el-form v-if="active === 6">
                      <app-stripe />
                    </el-form>
                  </div>
                </div>
                <div class="form-row mt-5" style="align-items: center">
                  <div class="col-6">
                    <div v-if="this.active > 1">
                      <button
                        type="button"
                        class="btn btn-primary el-button--default"
                        v-if="this.active < 4"
                        @click="previous"
                        :disabled="nextButton"

                      >
                        <span>Previous</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-6 ">
                    <el-button
                      v-if="this.active < 3"
                      class="btn btn-primary _remove_class float-right"

                      @click="next"
                      :disabled="nextButton"
                    >
                      Next step
                    </el-button>
                    <!-- <el-button
                      v-if="this.active == 3"
                      class="btn btn-primary _remove_class"
                      style="margin-top: 12px; float: right"
                      v-on:click="invite"
                      >Register</el-button
                    > -->
                    <app-load-more
                      v-if="this.active == 3"
                      :preloader="preloader"
                      :label="$t('register')"
                      type="submit"
                      class-name="btn btn-primary text-center float-right"
                      @submit="invite"
                    />
                  </div>
                </div>
              </div>

              <div class="form-row mt-5" v-if="this.active == 5">
                <div class="form-group col-12">
                  <!-- Go to <a href="#" v-on:click="login">Dashboard</a> withoutpaymet. -->
                  <a href="#" v-on:click="login">Signup without fee</a>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <p class="text-center">
                    {{ $t("copyright_text") + configData.company_name }}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThemeMixin from "../../../../../core/mixins/global/ThemeMixin";
import PasswordWarning from "../../Auth/PasswordWarning.vue";
import { AuthMixin } from "../../Auth/Mixins/AuthMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import {
  COMPANY_CHECK,
  COMPANY_STORE,
  GET_CATEGORIES,
  GET_CATEGORY,
  PACKAGES,
  USER_INVITATION,
  GET_COMPANY_DETAILS,
} from "../../../../Config/ApiUrl";
import AppButton from "../../../../../core/components/buttons/AppButton.vue";
import {validationType} from "@Views/Screening/utility/enums";

export default {
  name: "Registration",
  mixins: [AuthMixin, ThemeMixin],
  components: {
    PasswordWarning,
    AppButton,
  },
  props: {
    userInfo: {},
    siteKey: String,
    recaptchaEnable: {},
  },
  data() {
    return {
      validationType: validationType,
      validation: {
        forename : true,
        middle_name : true,
        surname : true,
        driver_license_number: true,
      },
      genderLists: [
        { id: "yes", value: "Yes" },
        { id: "no", value: "No" },
      ],
      showPopper: false,
      searchparam: "",
      user: {},
      userData: {},
      active: 1,
      links: [],
      state1: "",
      state2: "",
      company: {
        yes: "no",
        address_snippet:'N/A',
      },
      link: "",
      timeout: null,
      readOnly: false,
      packages: {},
      isHidden: true,
      showComponentOne: false,
      showComponentTwo: false,
      company_id: 0,
      nextButton: false,
      categories: [],
      category: {},
      subCategory: [],
    };
  },
  created() {
    if (this.userInfo) {
      this.userData = JSON.parse(this.userInfo);
    }
  },
  methods: {
    userNumber(sanitizedNo){
      this.user.number = sanitizedNo
    },
    loginHere() {
      window.location.href = "/admin/users/login";
    },
    invite() {
      this.preloader = true;
      this.loadershow = true;
      // this.user.company = this.company;
      axiosPost(USER_INVITATION, this.user)
        .then((res) => {
          this.emailMessage = "Please check your email.";
          this.$toastr.s("Please check your email.");
          this.createCompany();
        })
        .catch((error) => {
          
          if (error.message != "") {
            // this.$toastr.e(error.response);
            
            Object.values(error.response.data.errors).map((v, i) => {
              this.$toastr.e(v);
            });
          } else {
            this.message = error.response.data.errors.email[0];
            this.$toastr.e(this.message);
          }
          this.emailErrorShow = true;
          this.loadershow = false;
          this.preloader = false;
        })
        .finally(() => {
          this.mainPreloader = false;
          this.countCreatedResponse++;
          this.preloader = false;
        });
    },
    packagesListing() {
      axiosGet(PACKAGES)
        .then((res) => {
          this.packages = res.data.data;
          
        })
        .catch((res) => {
          
        });
    },
    submit() {
      let data = this.user;
      data.email = this.userData.email;
      data.invitation_token = this.userData.invitation_token;
      this.save(data);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      location.replace("/admin/users/login");
    },
    next() {

      let a = this.validator();
      if (a == false) {
        return;
      }
      if (this.active++ > 2) this.active = 1;
      $("#_remove_class_").removeClass("el-button");
    },
    validator() {
      if (this.active == 1) {
        if (!this.user.roles) {
          this.$toastr.e("Please select one of the roles below.");
          return false;
        }
      }
     
      if (this.active == 2) {
        
        if(this.company.yes == 'no')
        {
          this.company.address_snippet = 'Not Available';

        }

        let obj = Object.keys(this.company);
        let objData = this.company;

        if(!objData.title || !objData.company_number || !objData.address_line_1 || !objData.country || !objData.locality || !objData.postal_code || !objData.premises){
           this.$toastr.e("Fill missing fields");
           this.readOnly = false;
          return false;
        }
        if (!(obj.length >= 8)) {
          this.$toastr.e("fill all fields");
          return false;
        }
      }
      if (this.active == 3) {
        let obj2 = Object.keys(this.user);
        if (!(obj2.length == 7)) {
          this.$toastr.e("fill all fields");
          return false;
        }
      }
      if (this.active == 4) {
        // catagoery id sahi nh aarhi hai isko null hona chayea or select p set hona chayea burhan here
        let category_id = this.company.category_id;
        if (category_id == 2) {
          this.$toastr.e("Please select package");
          return false;
        }
      }
      return true;
    },
    previous() {
      if (this.active-- < 5) this.active = this.active--;
    },
    setRole(role) {
      this.user.roles = { 0: role };
      this.active = 2;
    },
    querySearch(queryString, cb) {
      this.searchparam = queryString;
      this.showPopper = true;
      const url = `${GET_COMPANY_DETAILS}/${queryString}`;
      axiosGet(url)
        .then((res) => {
          Object.keys(res.data.items).forEach((key) => {
            this.links[key] = {
              value:
                res.data.items[key].title +
                " (" +
                res.data.items[key].company_number +
                ")",
              link: res.data.items[key].company_number,
              company_status: res.data.items[key].company_status,
              address_snippet: res.data.items[key].address_snippet,
              address: res.data.items[key].address,
            };
          });
        })
        .catch((res) => {
          console.error(res);
        })
        .finally(() => {
          let links = this.links;
          let results = queryString
            ? links.filter(this.createFilter(queryString))
            : links;
          // call callback function to return suggestions
          cb(links);
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 3000 * Math.random());
        });
    },
    createFilter(queryString) {
      return (link) => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelectTwo() {
      let companyvalue = this.company.yes;
      if (companyvalue === "yes") {
        this.readOnly = false;
        this.company.title = "";
        this.company.company_number = "";
        this.company.address_line_1 = "";
        this.company.address_line_2 = "";
        this.company.country = "";
        this.company.locality = "";
        this.company.postal_code = "";
        this.company.premises = "";
        this.company.address_snippet = "";
        // this.company.status = "";
      } else {
        
      }
    },
    handleSelect(item) {
      item.value = item.value.replace(/ *\([^)]*\) */g, "");
      //   item.value.replace(/ /g, "\xa0");
      this.readOnly = true;
      this.company.title = item.value;
      this.company.company_number = item.link;
      this.company.address_line_1 = item.address.address_line_1;
      this.company.address_line_2 = item.address.address_line_2;
      this.company.country = item.address.country;
      this.company.locality = item.address.locality;
      this.company.postal_code = item.address.postal_code;
      this.company.premises = item.address.premises;
      this.company.address_snippet = item.address_snippet;
      this.company.status = 'active';
      this.companyCheck(item.link);
    },

    companyCheck(company_number) {
      axiosGet(COMPANY_CHECK + "/" + company_number)
        .then((res) => {
          if (res.data.status == true) {
            this.$toastr.e("Company account already created.");
            this.nextButton = true;
          } else {
            this.nextButton = false;
          }
        })
        .catch((error) => {
          
        });
    },

    createCompany() {
      axiosPost(COMPANY_STORE, {
        company: this.company,
        user: this.user,
      })
        .then((res) => {
          this.active = 4;
          this.link = res.data.route;
          
        })
        .catch((res) => {
          
        });
    },
    goDashboard() {
      window.location.href = this.link;
    },
    toggleComponentOne(type) {
      this.showComponentOne = !this.showComponentOne;
      this.isHidden = false;
      this.user.user_type = type;
    },
    payment(id) {
      this.company.package_id = id;
      this.invite();
      this.active = 6;
    },
    login() {
      axiosPost(COMPANY_STORE, {
        company: this.company,
        user: this.user,
      })
        .then((res) => {
          
        })
        .catch((res) => {
          
        });
    },
    getCategories() {
      axiosGet(GET_CATEGORIES)
        .then((res) => {
          this.categories = res.data;
          this.getCategory(this.categories[0].id);
        })
        .catch((error) => {
          
        });
    },
    getCategory(id) {
      axiosGet(GET_CATEGORY + "/" + id)
        .then((res) => {
          // $('.active_image > img').addClass('border_image');
          // $('.active_image > img').css('border', '2px solid black');
          this.category = res.data;
          this.getSubCategory(this.category.subCategories[0].id);
        })
        .catch((error) => {
          
        });
    },
    getSubCategory(id) {
      axiosGet(GET_CATEGORY + "/" + id)
        .then((res) => {
          this.subCategory = res.data;
          this.company.category_id = this.subCategory.id;
        })
        .catch((error) => {
          
        });
    },
  },
  // mounted: function
  mounted() {
    this.packagesListing();
    this.getCategories();
    this.user.email = this.userData.email;
    $("._remove_class").removeClass("el-button");
    $("body").click(function () {
      this.showPopper = false;
    });
  },

  computed: {
    isMobile() {

      let width = window.innerWidth;
      let stepsDirection = 'horizontal';
      if( width > 575){
        stepsDirection = 'vertical';
      }
      console.log("Direction --- ",stepsDirection);
      console.log("Width --- ", width);

      return stepsDirection;
    },

  },
};
</script>
<style scoped>
.search_link {
  font-weight: normal;
  background: #4466f2;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 8px;
  position: relative;
  left: -1px;
  color: white !important;
  cursor: pointer;
}
.title_class_registration {
  display: block !important;
  flex-direction: initial !important;
  text-align: -webkit-center !important;
}

.package_li {
  padding: 20px;
  text-align: center;
  background: grey;
  margin-bottom: 8px;
  margin-top: 8px;
  color: black;
}
.main-panel {
  display: flex;
  flex-direction: column;
  margin-left: 0px;
  width: calc(100% - 0px);
  min-height: calc(100vh- 0px);
  transition: width 0.25s ease-in-out, margin 0.25s ease-in-out;
}
.border_registration {
  background: #4466f2;
  border-radius: 0px;
  padding: 1.2rem !important;
}
.price_package {
  padding: 20px;
  text-align: center;
}

.subscrbe_button {
  background: transparent;
  border-radius: 0px;
  padding: 1.2rem !important;
}

/* demo */
.price {
  list-style-type: none;
  border: 1px solid #eee;
  margin: 0;
  padding: 0;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.price:hover {
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
}

.price .header {
  background-color: #111;
  color: white;
  font-size: 25px;
}

.price li {
  border-bottom: 1px solid #eee;
  padding: 20px;
  text-align: center;
}

.price .grey {
  background-color: #eee;
  font-size: 20px;
}
/* .card_background_effect::after{
    content: "";
    display: block;
    width: 0px;
    height: 0px;
    background-color: skyblue;
    top: 0px;
    right: 0px;
    border-bottom: 20px solid darken(teal, 5%);
    border-left: 20px solid darken(teal, 5%);
    border-right: 20px solid yellow;
    border-top: 20px solid yellow;
    position: absolute;
    filter: drop-shadow(-5px 5px 3px rgba(0,0,0,0.5));
} */
</style>
